module.exports = __webpack_public_path__ + "static/media/icon-vr.ffba459d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-vr.svg
// module id = 49
// module chunks = 0